// extracted by mini-css-extract-plugin
export default {"edit":"Header_edit__V44cb","cancel":"Header_cancel__wU7du"};